module.exports = __webpack_public_path__ + "static/img/siege_tower.900b2f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/siege_tower.png
// module id = lkwm
// module chunks = 0